module.exports = __webpack_public_path__ + "img/bed-icon.f406b89a.svg";